
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anniversary",
      function () {
        return require("private-next-pages/anniversary.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anniversary"])
      });
    }
  